import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const COMPANY_NAV = [
  { path: '/admin',             label: 'لوحة التحكم',    icon: ChartIcon,    end: true },
  { path: '/admin/fleet',        label: 'إدارة الأسطول',   icon: BusIcon },
  { path: '/admin/trips',        label: 'الرحلات',          icon: MapIcon },
  { path: '/admin/tracking',     label: 'مراقبة الرحلات',   icon: LocationIcon },
  { path: '/admin/bookings',     label: 'الحجوزات',         icon: TicketIcon },
  { path: '/admin/finance',      label: 'التقارير المالية', icon: MoneyIcon },
  { path: '/admin/obligations',  label: 'مستحقات المنصة',   icon: MoneyIcon },
  { path: '/admin/promos',       label: 'عروض الخصم',       icon: PromoIcon },
  { path: '/admin/offices',      label: 'مكاتب الحجز',      icon: OfficeIcon },
  { path: '/admin/parcels',      label: 'الطرود',           icon: ParcelIcon },
  { path: '/admin/staff',        label: 'فريق العمل',       icon: UsersIcon },
  { path: '/admin/profile',      label: 'ملف الشركة',       icon: BuildingIcon },
];

const SUPER_NAV = [
  { path: '/admin/super',                    label: 'لوحة التحكم',    icon: ChartIcon,    end: true },
  { path: '/admin/super/companies',          label: 'الشركات',         icon: BuildingIcon },
  { path: '/admin/super/passengers',         label: 'المسافرون',       icon: UsersIcon },
  { path: '/admin/super/bookings',           label: 'جميع الحجوزات',   icon: TicketIcon },
  { path: '/admin/super/settlements',        label: 'التسويات المالية', icon: MoneyIcon },
  { path: '/admin/super/offices',            label: 'مكاتب الحجز',     icon: OfficeIcon },
  { path: '/admin/super/parcels',            label: 'الطرود',          icon: ParcelIcon },
  { path: '/admin/super/transport-providers', label: 'مزودو النقل',    icon: BusIcon },
  { path: '/admin/super/transport-payments', label: 'دفعات النقل',    icon: MoneyIcon },
  { path: '/admin/super/commission',         label: 'إدارة العمولات',  icon: MoneyIcon },
  { path: '/admin/super/city-codes',         label: 'رموز المدن',      icon: MapIcon },
  { path: '/admin/super/vehicle-types',      label: 'أنواع المركبات',  icon: BusIcon },
  { path: '/admin/super/popular-routes',     label: 'الوجهات الشائعة', icon: PromoIcon },
  { path: '/admin/super/profile',            label: 'ملفي الشخصي',     icon: PersonIcon },
];

const STAFF_NAV = [
  { path: '/admin/boarding', label: 'تسجيل الصعود', icon: TicketIcon, end: true },
];

const ROLE_LABELS = {
  company_admin: 'مدير شركة',
  super_admin:   'مدير عام',
  driver:        'سائق',
  bus_host:      'مضيف البص',
};

function ChartIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  );
}

function BusIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h8M8 11h8M5 3h14a2 2 0 012 2v13a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zM7 20v1m10-1v1" />
    </svg>
  );
}

function MapIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
    </svg>
  );
}

function TicketIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
    </svg>
  );
}

function MoneyIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

function UsersIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  );
}

function LocationIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );
}

function BuildingIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  );
}

function PromoIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
    </svg>
  );
}

function PersonIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  );
}

function OfficeIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 22V12h6v10" />
    </svg>
  );
}

function ParcelIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5m0-13v13m9-13v8l-9 5" />
    </svg>
  );
}

const SidebarContent = ({ isSuper, isStaff, navItems, initials, user, onClose, handleLogout }) => (
  <aside
    className={`w-64 min-h-screen flex flex-col ${isSuper ? 'bg-gray-900' : 'bg-slate-800'}`}
    dir="rtl"
  >
    {/* Logo */}
    <div className={`px-5 py-5 border-b ${isSuper ? 'border-gray-700/60' : 'border-slate-700/60'} flex items-center justify-between`}>
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="سافر" className="w-16 h-16 object-contain rounded-2xl" />
        <p className={`text-sm font-semibold ${isSuper ? 'text-yellow-400' : 'text-blue-400'}`}>
          {isSuper ? 'المدير العام' : isStaff ? 'بوابة الطاقم' : 'لوحة الشركة'}
        </p>
      </div>
      {/* Close button — mobile only */}
      <button
        onClick={onClose}
        className="lg:hidden text-slate-400 hover:text-white p-1 rounded-lg"
        aria-label="إغلاق القائمة"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    {/* Nav */}
    <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
      {navItems.map(({ path, label, icon: Icon, end }) => (
        <NavLink
          key={path}
          to={path}
          end={end || false}
          onClick={onClose}
          className={({ isActive }) =>
            `group flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-150 ${
              isActive
                ? isSuper
                  ? 'bg-yellow-500/10 text-yellow-400 border border-yellow-500/20'
                  : 'bg-blue-500/15 text-blue-300 border border-blue-500/20'
                : 'text-slate-400 hover:bg-white/5 hover:text-white border border-transparent'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon className={`w-5 h-5 flex-shrink-0 ${isActive ? (isSuper ? 'text-yellow-400' : 'text-blue-400') : 'text-slate-500 group-hover:text-slate-300'}`} />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>

    {/* User info + logout */}
    <div className={`px-4 py-4 border-t ${isSuper ? 'border-gray-700/60' : 'border-slate-700/60'}`}>
      <div className="flex items-center gap-3 mb-3">
        <div className={`w-9 h-9 rounded-xl flex items-center justify-center font-bold text-sm flex-shrink-0 ${isSuper ? 'bg-yellow-500 text-gray-900' : 'bg-blue-600 text-white'}`}>
          {initials}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-medium truncate">{user?.name}</p>
          <p className="text-slate-500 text-xs">{ROLE_LABELS[user?.role] || user?.role}</p>
        </div>
      </div>
      <button
        onClick={handleLogout}
        className="w-full flex items-center justify-center gap-2 bg-red-500/10 hover:bg-red-500/20 text-red-400 hover:text-red-300 py-2 rounded-xl transition-colors text-sm font-medium border border-red-500/20"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        تسجيل الخروج
      </button>
    </div>
  </aside>
);

const Sidebar = ({ open, onClose }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isSuper = user?.role === 'super_admin';
  const isStaff = ['driver', 'bus_host'].includes(user?.role);
  const navItems = isSuper ? SUPER_NAV : isStaff ? STAFF_NAV : COMPANY_NAV;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = user?.name
    ? user.name.split(' ').slice(0, 2).map((w) => w[0]).join('')
    : '؟';

  const props = { isSuper, isStaff, navItems, initials, user, onClose, handleLogout };

  return (
    <>
      {/* Desktop: always-visible sidebar */}
      <div className="hidden lg:block flex-shrink-0">
        <SidebarContent {...props} />
      </div>

      {/* Mobile: slide-in drawer from right */}
      {open && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/60 z-40 lg:hidden"
            onClick={onClose}
          />
          {/* Drawer */}
          <div className="fixed inset-y-0 right-0 z-50 lg:hidden">
            <SidebarContent {...props} />
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;
